<template>
  <div style="margin: 10px">
    <v-card>
      <template v-for="(value,key) in dataByDate">
      <v-card-text v-if="checkDate(key)" :key="key">
        <label>Ngày:</label> {{ key | formatDate }}
        <table class="lstTable">
          <tr>
            <th width="100px">Mã vụ</th>
            <th width="20px">Tuổi tôm</th>
            <th width="20px">Số lượng giống</th>
            <th width="20px">Thức ăn</th>
            <th width="20px">Khối lượng</th>
            <th width="20px">Tổng Kl thức ăn</th>
            <th width="20px">Size tôm (con/kg)</th>
            <th width="20px">Tổng khối lượng dự tính</th>
            <th  v-for="(item, k2) in lstIndex" :key="k2" width="20px">
              {{ $t(item.envName) }} ({{ item.unitType }})
            </th>
            <th width="20px">G</th>
            <th width="20px">Tỉ lệ tôm sống (%)</th>
            <th width="20px">Hệ số thức ăn</th>
            <th width="50px">
              {{ $t("lang.envMeasure.note") }}
            </th>
          </tr>
          <template v-for="(item) in value">
            <template
                v-if="item.material != undefined && item.material != null && item.material.length > 0"
            >
              <tr v-for="(material, index) in item.material" :key="index">
                <td v-if="index==0" :rowspan="item.material.length">{{ item.code }}
                </td>
                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  {{ item.shrimpAge }}
                </td>
                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  {{item.numberOfSeed}}
                  <!--                                so luong giong-->
                </td>
                <td>
                  {{ material.materialName }}
                </td>
                <td>
                  {{ material.total_export }}
                </td>
                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  {{item.totalFood|currency}}
                  <!--                                tong kl thuc an-->
                </td>
                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  <div style="text-align: right"
                      v-if="item.pmIdx['shrimpSize'] != undefined && item.pmIdx['shrimpSize'] != null && item.pmIdx['shrimpSize'] != ''">
                    {{ item.pmIdx["shrimpSize"] }}
                  </div>
                  <div style="text-align: right" v-else>
                    {{ item.amIdx["shrimpSize"] }}
                  </div>
                </td>
                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  {{ getQuantity(item) > 0 ? (getQuantity(item)|currency) : '-' }}
                </td>

                <td v-for="(idx, k3) in lstIndex" style="text-align: right" v-if="index==0" :rowspan="item.material.length" :key="k3">
                  <div
                      v-if="item.pmIdx[idx.envId] != undefined && item.pmIdx[idx.envId] != null && item.pmIdx[idx.envId] != ''">
                    {{ item.pmIdx[idx.envId] }}
                  </div>
                  <div v-else>
                    {{ item.amIdx[idx.envId] }}
                  </div>
                </td>

                <td v-if="index==0" :rowspan="item.material.length">
                  <div v-if="item.pmIdx.g != undefined && item.pmIdx.g != null && item.pmIdx.g != ''">
                    {{ item.pmIdx.g }}
                  </div>
                  <div v-else>
                    {{ item.amIdx.g }}
                  </div>
                </td>
                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  <div style="text-align: right"
                      v-if="item.pmIdx['livePercent'] != undefined && item.pmIdx['livePercent'] != null && item.pmIdx['livePercent'] != ''">
                    {{ item.pmIdx["livePercent"] }}
                  </div>
                  <div style="text-align: right" v-else>
                    {{ item.amIdx["livePercent"] }}
                  </div>
                </td>

                <td v-if="index==0" :rowspan="item.material.length" style="text-align: right">
                    {{getHesothucan(item)}}
                </td>
                <td v-if="index==0" :rowspan="item.material.length">{{ item.notes }}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td>{{ item.code }}
                </td>
                <td style="text-align: right">
                  {{ item.shrimpAge }}
                </td>
                <td>
                  {{item.numberOfSeed}}
                </td>
                <td>

                </td>
                <td></td>
                <td>{{item.totalFood|currency}}</td>

                <td style="text-align: right"
                    v-if="item.pmIdx['shrimpSize'] != undefined && item.pmIdx['shrimpSize'] != null && item.pmIdx['shrimpSize'] != ''">
                  {{ item.pmIdx["shrimpSize"] }}
                </td>
                <td style="text-align: right" v-else>
                  {{ item.amIdx["shrimpSize"] }}
                </td>
                <td style="text-align: right">
                  {{ getQuantity(item) > 0 ? (getQuantity(item)|currency) : '-' }}
                </td>


                <td v-for="idx in lstIndex" style="text-align: right">
                  <div
                      v-if="item.pmIdx[idx.envId] != undefined && item.pmIdx[idx.envId] != null && item.pmIdx[idx.envId] != ''">
                    {{ item.pmIdx[idx.envId] }}
                  </div>
                  <div v-else>
                    {{ item.amIdx[idx.envId] }}
                  </div>
                </td>
                <td>
                  <div v-if="item.pmIdx.g != undefined && item.pmIdx.g != null && item.pmIdx.g != ''">
                    {{ item.pmIdx.g }}
                  </div>
                  <div v-else>
                    {{ item.amIdx.g }}
                  </div>
                </td>
                <td style="text-align: right"
                    v-if="item.pmIdx['livePercent'] != undefined && item.pmIdx['livePercent'] != null && item.pmIdx['livePercent'] != ''">
                  {{ item.pmIdx["livePercent"] }}
                </td>
                <td style="text-align: right" v-else>
                  {{ item.amIdx["livePercent"] }}
                </td>
                <td style="text-align: right">{{getHesothucan(item)}}</td>
                <td>{{ item.notes }}</td>
              </tr>
            </template>
          </template>
        </table>
      </v-card-text>
      </template>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import {message} from "../../shared/message";
import moment from "moment";

export default {
  name: "pond-report-summary",
  components: {},
  props: {
    search: {
      type: Object,
      default: () => {
        return null;
      },
    },

    reportData: {
      type: Object,
      default: () => {
        return null;
      },
    }

  },

  watch: {},

  data: () => {
    return {
      lstIndex: [],
      dataByDate: {},
      g: null,
      numberOfSeed: 0,

    };
  },

  created() {
    this.getEnvIndex();
  },

  methods: {
    shrimpAgeByDate(crop, calculateDate) {
      let shrimpAge = 0;
      let dropDate = '';
      if (parseInt(crop.pondParent) > 0 && crop.dropDateParent != '' && crop.dropDateParent != null) {
        dropDate = moment(String(crop.dropDateParent));
      } else if (crop.dropDate != '' && crop.dropDate != null) {
        dropDate = moment(String(crop.dropDate));
      }
      // console.log(dropDate);
      if (dropDate != '') {
        let calculateDateMM = moment(calculateDate);
        let endDate = moment(calculateDate);
        if (crop.endDate) {
          endDate = moment(String(crop.endDate));
          if (endDate > calculateDateMM) endDate = calculateDateMM;
        }
        if (endDate > dropDate) {
          let dates = endDate.diff(dropDate, "days");
          if (dates >= 0) {
            shrimpAge = dates;
          }
        }
      }
      return shrimpAge;

    },

    getQuantity(item) {
      let quantity = item.numberOfSeed;
      let livePercent = item.pmIdx["livePercent"];
      if (livePercent == undefined || livePercent == null) {
        livePercent = item.amIdx["livePercent"];
      }
      let shrimpSize = item.pmIdx["shrimpSize"];
      if (shrimpSize == undefined || shrimpSize == null) {
        shrimpSize = item.amIdx["shrimpSize"];
      }

      if(livePercent == undefined){
        item.quantity = '';
        quantity = '';
      } else{
        quantity = (item.numberOfSeed * livePercent) / (shrimpSize * 100);
        item.quantity = quantity;
      }
      
      return quantity;
    },

    getHesothucan(item) {
      // let tongkhoiluongdutinh = item.quantity;
      let tongkhoiluongdutinh = this.getQuantity(item);
      let hesothucan = 0;
      if(tongkhoiluongdutinh == undefined || tongkhoiluongdutinh == ''){
        item.hesothucan = 0;
        hesothucan = 0;
      } else{
        hesothucan = item.totalFood / tongkhoiluongdutinh;
        item.hesothucan = hesothucan;
      }
      let roundedString = '-';
      if (hesothucan != null && hesothucan > 0) {
        roundedString = hesothucan.toFixed(4);
        roundedString = roundedString.replace('.', ',');
      } 
      return roundedString;
    },

    getEnvIndex() {
      axios.post(
          process.env.VUE_APP_API_URL + "/envIndex/search?pageSize=-1&page=0", {}
      ).then(
          (data) => {
            this.lstIndex = data.items;
          }
      );
    },

    reCalculate() {
      console.log("recalculate");
      // console.log("search",this.search);
      const self = this;
      this.dataByDate = {};
      console.log('reportData', this.reportData);
      for (let key in this.reportData) {
        let dt = this.reportData[key].data;
        // console.log("data", dt);
        let crop = this.reportData[key].crop;
        for (let i = 0; i < dt.length; i++) {
          dt[i].code = crop.code;
          if (this.dataByDate[dt[i].measureDate] == undefined) {
            this.dataByDate[dt[i].measureDate] = [dt[i]];
          } else {
            this.dataByDate[dt[i].measureDate].push(dt[i]);
          }
        }
      }
      console.log("dataByDate",this.dataByDate);
      this.$emit("finishCalculate");
    },

    checkDate(date) {
      return moment(date) >= moment(this.search.fromDate);
    },
  },

  destroyed() {
  },
};
</script>

<style>
.indicator {
  margin: 5px 5px 5px 0px;
  padding: 5px;
  display: inline-block;
  border: 1px solid gray;
  width: fit-content;
}

.G2 {
  background-color: gold;
}

.G3 {
  background-color: crimson;
}
</style>